import { render } from "./habilidad.vue?vue&type=template&id=63f43b0a&scoped=true"
import script from "./habilidad.vue?vue&type=script&lang=js"
export * from "./habilidad.vue?vue&type=script&lang=js"

import "./habilidad.vue?vue&type=style&index=0&id=63f43b0a&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f43b0a"]])

export default __exports__